import styled from 'styled-components';

import { theme } from 'assets/styles/theme';

import ButtonBase from './ButtonBase';

const InfoButton = styled(ButtonBase)`
  height: 100%;
  width: 195px;
  border: 1px solid ${theme.color.white};
  background-color: ${theme.color.blue};
  color: ${theme.color.white};
  cursor: pointer;

  ${theme.mq.phone} {
    width: auto;
    min-width: 0;
    padding: 0 12px;
    font-size: 13px;
    line-height: 16px;
    height: 32px;
    white-space: nowrap;
  }

  &:hover {
    opacity: 0.5;
  }
`;

export default InfoButton;
